import React, { InputHTMLAttributes } from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

interface CustomProps
  extends NumberFormatProps<InputHTMLAttributes<HTMLInputElement>> {
  onChange: (_event: { target: { name: string; value: string } }) => void;
  name: string;
}

const MaskedInput = React.forwardRef<HTMLInputElement, CustomProps>(
  function MaskedInput(props, ref) {
    const { onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        customNumerals={['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']}
        onValueChange={(values: any) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
      />
    );
  }
);

export default MaskedInput;
